import React from 'react';
import { createPortal } from 'react-dom';
import EmailAiPopup from '../../EmailAiPopup';
import EmailPopup from '../../EmailPopup';
import '../../BulkEmailPopup.css';

/**
 * Opens parked SafeGuard mails in the regular send modes: one mail in Normal
 * mode, all of them in Bulk mode — prefilled, nothing generated.
 */
export default function SafeGuardResendPopup({ session, userId, onEmailResult, onClose }) {
  if (!session) return null;

  if (session.mode === 'single') {
    return (
      <EmailPopup
        isPopupOpen
        rowData={session.rowData}
        userId={userId}
        onEmailResult={onEmailResult}
        closePopup={onClose}
      />
    );
  }

  const ids = session.contacts.map((c) => c.id);
  return createPortal(
    <div className="bulk-email-popup-container">
      <EmailAiPopup
        onClose={onClose}
        rowData={session.contacts[0]}
        userId={userId}
        onEmailResult={onEmailResult}
        source="worldDbTable"
        bulkMode
        bulkContacts={ids}
        allData={session.contacts}
        presetEmails={session.presetEmails}
      />
    </div>,
    document.body
  );
}
